module.exports = __webpack_public_path__ + "static/media/cp01.9a95d779.jpg";